import * as Yup from 'yup';
import moment from 'moment';

// W-0503 — GES Matricial de Despesas — Usuário Alternativo
// 10 validações V-01..V-10 com mensagens literais do Delphi (MAPEAMENTO M4)

const buildSchema = (codigoTitular) =>
  Yup.object().shape({
    codigoUsuarioAlternativo: Yup.number()
      .nullable()
      .required('Usuário alternativo deve ser informado.')
      .positive()
      .integer()
      .test(
        'nao-titular',
        'Usuário alternativo não pode ser o usuário selecionado.',
        (val) => val !== codigoTitular
      ),
    dataInicio: Yup.string()
      .nullable()
      .required('Data início deve ser informada.')
      .test('valida', 'Data início informada não é válida.', (val) => {
        if (!val) return false;
        return moment(val, 'YYYY-MM-DD', true).isValid();
      })
      .test(
        'min-hoje',
        'Data início informada deve ser maior ou igual a data de hoje.',
        (val) => {
          if (!val) return false;
          return moment(val, 'YYYY-MM-DD').isSameOrAfter(
            moment().startOf('day')
          );
        }
      ),
    dataFim: Yup.string()
      .nullable()
      .required('Data fim deve ser informada.')
      .test('valida', 'Data fim informada não é válida.', (val) => {
        if (!val) return false;
        return moment(val, 'YYYY-MM-DD', true).isValid();
      })
      .test(
        'min-hoje',
        'Data fim informada deve ser maior ou igual a data de hoje.',
        (val) => {
          if (!val) return false;
          return moment(val, 'YYYY-MM-DD').isSameOrAfter(
            moment().startOf('day')
          );
        }
      )
      .test(
        'dateOrder',
        'Data início deve ser menor ou igual a data fim.',
        function (dataFim) {
          const { dataInicio } = this.parent;
          if (!dataInicio || !dataFim) return true;
          return moment(dataInicio, 'YYYY-MM-DD').isSameOrBefore(
            moment(dataFim, 'YYYY-MM-DD')
          );
        }
      ),
  });

export default buildSchema;
